export enum ProductStyle {
  COLOR = "COLOR",
  IMAGE = "IMAGE",
}
